import { ComponentPropsWithRef } from "react";

export enum IconLibrary {
  GoogleMaterial = "ic",
  MaterialSymbolsRounded = "material-symbols-rounded",
  MaterialSymbols = "material-symbols",
  FontAwesomeRegular = "fa6-regular",
}

export interface KameleonIconProps extends ComponentPropsWithRef<any> {
  name: string;
  height?: string;
}

export type IconMappings = {
  [K in IconLibrary]: string;
};

export enum IconType {
  Home = "home",
  Check = "check",
  ArrowRight = "arrow-right",
  ChevronRight = "chevron-right",
  ArrowLeft = "arrow-left",
  ChevronLeft = "chevron-left",
  ArrowDown = "arrow-down",
}
